/**
 * src/modules/dashboard/componentes/plano7dias.js
 * -----------------------------------------------------------------------------
 * Componente Plano de Ação 7 Dias para dashboard público.
 * - Recebe HTML do plano em payload.data.planejamentoescolhido.descricao.
 * - Exibe filtros aplicados no topo.
 */





import React from 'react';
import './plano7dias.scss';

export default function Plano7dias({
  nls = {},          // nls global (para "filtrosAplicados")
  componentNls = {}, // nls do tópico (para "semdadosparaexibir")
  filtros = [],
  payloadData = {}   // payload.data
}) {
  const descricao = payloadData?.planejamentoescolhido?.descricao;
  const semDados = componentNls?.semdadosparaexibir || nls?.semdadosparaexibir || 'Sem dados para exibir.';

  const conteudoHTML = descricao
    ? descricao.replace(/className/g, 'class')
    : `<div class="plano7dias-content" style="text-align:center;">${semDados}</div>`;

  return (
    <section className="box-content-like plano7dias-wrapper">
      {/* Filtros aplicados */}
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Conteúdo do plano */}
      <div dangerouslySetInnerHTML={{ __html: conteudoHTML }} />
    </section>
  );
}

/*

JSON DE INPUT:

{
      "nls": {
        "resumo": "Resumo das Experiências de Compra dos Clientes",
        "listaplanos": "Plano de Ação",
        "semdadosparaexibir": "No data"
      },
      "label": "Plano de Ação Semanal",
      "params": {
        "empresaId": 225,
        "framework": "YT7dias",
        "IdiomaIdUser": 1,
        "IdPlanejamento": 1822  /OPCIONAL, SE NÃO PASSAR PEGA O PRIMEIRO
      },
      "Filtros": [
        {
          "nomedofiltro": "Período Semanal",
          "valordofiltro": "01/09/2025 to 07/09/2025"
        },
        {
          "nomedofiltro": "Empresa",
          "valordofiltro": "Mc Donald's"
        }
      ],
      "ordinal": 8,
      "topicKey": "plano7dias"
    }

*/

